"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkillBarPart = exports.SkillBar = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _helper = require("./helper");

var SkillBar =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1osdew50"
})("display:flex;flex-direction:row;");
exports.SkillBar = SkillBar;
var SkillBarPart =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1osdew51"
})(function (_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      rating = _ref.rating,
      editable = _ref.editable,
      index = _ref.index;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("cursor:", editable ? 'pointer' : 'auto', ";margin-right:", size === 'large' ? '6.7px' : '4px', ";width:", size === 'large' ? '30px' : '18px', ";height:", size === 'large' ? '10px' : '6px', ";border-radius:", size === 'large' ? '4px' : '2px', ";transition:background-color 0.4s ease;background:", index <= rating ? theme.color[(0, _helper.getRatingColor)(rating)] : theme.color.grey3, ";")
  );
});
exports.SkillBarPart = SkillBarPart;